import React, {Component} from 'react';
import { connect } from 'react-redux';

class HourButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selected ? this.props.selected : false
        };

        this.selectDeselectHour = this.selectDeselectHour.bind(this);
    }


    selectDeselectHour = () => {
            this.setState({
                selected: !this.state.selected
            })

            return this.props.handleInteractivity ? this.props.handleInteractivity() : '';
        
    }

    render() {
        return(   
            <div className={`hour-button ${this.props.hour === this.props.selectedValue ? 'selected' : ''}`} onClick={this.selectDeselectHour} >
                <span className="radius-item">{this.props.projectionFormat}</span>
                <span className="hour-item">{this.props.hour}</span>
            </div>
        )
    }
}

const mapStateToProps = state => ({

});

export default connect(mapStateToProps, {})(HourButton);


// WEBPACK FOOTER //
// ./src/SHARED/components/hourbutton/hourbutton.component.js